import "../styles/text.css"

const TermsAndConditions = () => {
    return (
        <div className="faq">
        <h2> TERMINOS Y CONDICIONES </h2>

        <br/>
        <br/>
        <br/>

        <b>1. Uso del Website</b>

        <p>Mediante el uso de este sitio web WWW.BEETGIFTS.COM aceptas los Términos y Condiciones que aquí
        se especifican.
        Si eres menor de 18 años no puedes realizar la compra de bebidas alcohólicas.
        Toda la información que proporciones a través de este sitio debe ser verdadera y exacta.
        Todo el contenido de este sitio, incluyendo la manera enunciativa: logotipos, diseños, fotografías,
        videos, textos gráficos, ícenos, nombres comerciales, copyright, así como la disposición y presentación
        de los mismos, son propiedad exclusiva de Beet o cuentan con licencias correspondientes para su uso.
        Queda estrictamente prohibida su reproducción, distribución, modificación, transmisión, publicación,
        exhibición o cualquier otro uso no autorizado sin el previo consentimiento expreso por escrito de Beet.
        </p>
        <br/>

        <b>2. Compra de Productos y Regalos</b>
        <p>
        Todos los pedidos realizados a través de este sitio están sujetos a disponibilidad. En el caso que alguno
        de los productos no estuviere disponible, se le notificará por medio del número de contacto o el correo
        brindado al momento de la compra. Podrás optar por reemplazar el producto no disponible por alguno
        similar, de igual o mayor valor, u optar por anular el pedido completo y obtener el reembolso del mismo.
        Todos los detalles de los productos tal como precios, características y descripción se encuentran
        especificados en la tienda digital. Cabe mencionar que los precios reflejados ya incluyen IVA.
        Todas las imágenes de los productos que aparecen en nuestra tienda son reales y exactos. En el caso
        que alguna imagen sea usada con fines ilustrativos o como referencia, esto estará indicado en la
        descripción del producto.
        Para los productos que requieren personalización, favor validar en la descripción del producto el tiempo
        de entrega ya que algunos de éstos pueden demorar hasta 72 horas.
        Cupones de descuento u ofertas tendrán validez según indicado y publicado en este sitio web.
        </p>
        <br/>

        <b>3. Cancelación de pedido y devoluciones</b>
        <p>
        Cada usuario tiene derecho a cancelar un pedido siempre y cuando éste no conlleve personalizaciones.
        Para solicitar la anulación, deberá comunicarse directamente a nuestro WhatsApp 7602-5162 y/o enviar
        un correo a hello@beetgifts.com indicando el motivo de la anulación y anexando un comprobante del
        pedido. Posteriormente, se realizará un reembolso completo del pedido realizado.
        En el caso que algún producto presente desperfectos de fábrica, podrá solicitar el cambio del mismo a
        través de los contactos brindados en el punto anterior. Para esto, deberá presentar el comprobante de
        pago o el número de referencia de la compra realizada. El tiempo máximo para solicitar devolución por
        desperfectos es de 15 días, siempre y cuando el producto esté en su empaque original y no presente
        daños por uso.
        El reembolso se realizará mediante el método de pago utilizado durante la compra. En el caso de
        tarjetas de débito o crédito, la acreditación de los fondos depende de la institución bancaria a la que
        pertenece la tarjeta.
        </p>
        <br/>

        <b>4. Condiciones y métodos de pago</b>
        <p>
        El usuario podrá realizar el pago de sus compras a través de los siguientes métodos:
        - Tarjeta de débito o crédito en página web: nuestra plataforma de pagos es liderada por Serfinsa y
        contamos con el sello de seguridad SSL Certificate para proteger tu información
        - Link de pago: escribir al WhatsApp 7602-5162 y solicitar tu link de pago para realizar tu compra de
        forma directa y digital
        - Transferencia bancaria: puedes realizar el abono a nuestras cuentas bancarias y enviar el
        comprobante al WhatsApp 7602-5162 para procesar tu pedido
        - Efectivo: Aplica únicamente para la compra de productos o regalos no personalizados
        En el caso de compras corporativas o pedidos mayores a $500, favor comunicarse directamente a
        nuestro WhatsApp 7602-5162.
        </p>
        <br/>

        <b>5. Condiciones de Promociones y Cupones</b>
        <p>Los cupones de descuento, códigos promocionales u ofertas especiales emitidos por Beet estarán
        sujetos a las siguientes condiciones:
        - Tendrán validez únicamente en las fechas y bajo las condiciones expresamente indicadas en la
        promoción
        - No son acumulables con otras promociones, descuentos u ofertas vigentes, salvo que se indique lo
        contrario

        - No son transferibles ni canjeables por dinero en efectivo
        - Aplican únicamente para los productos especificados en la promoción
        - En caso de devolución o cancelación del pedido, el valor del cupón no será reembolsable ni podrá
        reutilizarse
        </p>
        <br/>

        <b>6. Servicio de entregas a domicilio</b>
        <p>Contamos con entregas en todo el país.
        La tarifa para entregas en San Salvador (AMSS) es de $3.99 y para entregas departamentales es de
        $11.99.
        Los regalos que se encuentran en nuestro Online Shop bajo la categoría “Ready-to-Gift" pueden
        entregados el mismo día en las zonas de San Salvador y La Libertad, siempre y cuando el pedido se
        realice antes de las 10:00 AM. En caso que sean pedidos luego de esa hora, están sujetos a ser
        entregados el próximo día, en horas hábiles. Para las entregas departamentales, se deben pedir con al
        menos 48 horas de anticipación.
        Los regalos que conlleven personalizaciones especiales como grabados láser, bordados u otros, pueden
        tomar al menos 48 horas para ser entregados. Esto será acordado con nuestro equipo al momento de la
        compra.
        </p>
        <br/>

        <b>7. Horarios de atención</b>
        <p>
        Nuestro horario de atención es de Lunes a viernes de 8:00 AM a 5:30 PM.
        Contactos: Whatsapp o llamadas al 7602-5162 | Correo: hello@beetgifts.com
        </p>
        <br/>
        <b>8. Política de Privacidad y Protección de Datos</b>
        <p>Tu información personal proporcionada en esta sitio será utilizada únicamente para la comunicación
        entre Beet y el cliente. No será compartida con terceros, salvo que la ley lo requiera.
        </p>
        <br/>
        <b>9. Limitación de responsabilidad</b>
        <p>Beet no será responsable por retrasos o incumplimientos en la entrega de pedidos que se deriven de
        situaciones de fuerza mayor o ajenas a nuestro control, tal como condiciones climáticas extremas,
        desastres naturales, emergencias nacionales o cualquier otro evento imprevisible que imposibilite
        temporalmente el cumplimiento de nuestras obligaciones.

        Asimismo, en el caso de productos personalizados, Beet no asume responsabilidad por errores en
        nombres, fechas, mensajes o cualquier otro texto o datos proporcionados erróneamente por el cliente al
        momento de poner su pedido. La verificación y exactitud de la información es responsabilidad exclusiva
        del cliente.
        En cualquier de las situaciones anteriores, Beet se compromete a notificar y mantener comunicación
        con enciente, y cuando corresponde, ofrecer alternativas de soluciones razonables.
        </p>
        <br/>
        <b>10. Jurisdicción aplicable</b>
        <p>Estos Términos y Condiciones se rigen por las leyes de la República de El Salvador.
        Cualquier controversia, reclamo o disputa que surja en relación con el uso de este sitio web o con las
        transacciones realizadas a través del mismo será sometida a la jurisdicción de los tribunales
        competentes de El Salvador.
        </p>
        </div>
    );
}

export default TermsAndConditions;